// Video Player


function ContentImage(props) {


  return (
    <div className="page-content-image">
      <img src={props.baseurl + props.content.url} />
    </div>
  );
}

export default ContentImage;
